module.exports = __webpack_public_path__ + "9baaa345acddaabf7297addc52d151c8.svg";